import { useContext, useEffect } from "react";
import useBatchProcessStore from "../../store/batchProcessStore";
import { useGetJobStatus } from "../services/jobStatusService";
import TenantContext from "../context/TenantContext";

const useJobStatusData = () => {
  const { isProcessing, setJobStatus, batchId } = useBatchProcessStore();
  const { tenant } = useContext(TenantContext);
  const { data } = useGetJobStatus(
    tenant?.id || "",
    batchId || "",
    3000,
    isProcessing && !!batchId
  );

  useEffect(() => {
    if (data) {
      setJobStatus(data);
    }
  }, [data, batchId, setJobStatus]);
};

export default useJobStatusData;
